import { IconChevronDown } from '@tabler/icons';

export const DashboardSelectIcon = (props: Record<string, any>) => (
    <IconChevronDown style={{ margin: '-5px 0px', color: '#37326E' }} {...props} />
);
